<template>

            <div class="browser-support">
              <span class="browser-support-text">{{i18n['screen.welcome.label.browsersupport']||'浏览器支持'}}：</span>
              <img src="@/assets/img/chrome-icon.png" alt="Chrome"> 
              <img src="@/assets/img/firefox-icon.png" alt="Firefox"> 
              <img src="@/assets/img/ie-icon.png" alt="IE"> 
              <img src="@/assets/img/qq-icon.png" alt="QQ"> 
            </div>

</template>

<script>
export default {
  props: [
    'i18n',
    'config',
  ],
  data: function data() {
    return {
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
  },
  methods:{
  }
}
</script>
